import { useState } from 'react';
import { useGameStore } from '@/state/gameStore';
import { useT } from '@/i18n';
import { xpRequiredForLevel } from '@/domain/constants';
import { SettingsModal } from '@/ui/components/SettingsModal';
import { PlayerAvatar } from '@/ui/components/PlayerAvatar';
import './TopHud.css';

function formatNumber(n: number): string {
  return n.toLocaleString('de-DE');
}

export function TopHud() {
  const player = useGameStore((s) => s.player);
  const t = useT();
  const [settingsOpen, setSettingsOpen] = useState(false);
  if (!player) return null;

  const nextLevelXp = xpRequiredForLevel(player.level + 1);
  const xpPct = nextLevelXp > 0 ? Math.min(100, (player.xp / nextLevelXp) * 100) : 100;

  return (
    <>
      <header className="top-hud">
        <div className="top-hud__runner">
          <PlayerAvatar name={player.name} avatarColor={player.avatarColor ?? 'blue'} size="sm" />
          <div className="top-hud__runner-text">
            <div className="top-hud__name">{player.name}</div>
            <div className="top-hud__level">
              {t.hud.level} {player.level}
            </div>
          </div>
          <div className="top-hud__xp">
            <div className="top-hud__xp-bar" style={{ width: `${xpPct}%` }} />
          </div>
        </div>

        <div className="top-hud__currencies">
          <div className="top-hud__currency top-hud__currency--cd" title={t.hud.corruptedData}>
            <span className="top-hud__currency-icon">⌬</span>
            <span className="top-hud__currency-value">{formatNumber(player.corruptedData ?? 0)}</span>
          </div>
          <div className="top-hud__currency top-hud__currency--credits" title={t.hud.cleanCode}>
            <span className="top-hud__currency-icon">◈</span>
            <span className="top-hud__currency-value">{formatNumber(player.cleanCode ?? 0)}</span>
          </div>
          <div className="top-hud__currency top-hud__currency--premium" title={t.hud.neonGems}>
            <span className="top-hud__currency-icon">◇</span>
            <span className="top-hud__currency-value">{formatNumber(player.neonGems ?? 0)}</span>
          </div>
          <button
            type="button"
            className="top-hud__settings"
            onClick={() => setSettingsOpen(true)}
            aria-label="Einstellungen"
            title="Einstellungen / Abmelden"
          >
            ⚙
          </button>
        </div>
      </header>

      {settingsOpen && <SettingsModal onClose={() => setSettingsOpen(false)} />}
    </>
  );
}
